const initialState = {
  // firstname: '',
  // surname: '',
  // emailAddress: '',
  // country: '',
  // gender: '',
  // organization: '',
  // studentLevel: '',
  // otherStudentLevel: '',
  // wantCertificateOfParticipation: null,
  // attendanceOption: '',
  errors: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        ...action.payload,
      };
    case "reset":
      return initialState;
    default:
      return state;
  }
};

export { initialState, reducer };
